export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "daily_horoscope": "దైనిక రాశిఫలం",
    "daily_cosmic_guidance": "దైనిక కాస్మిక్ మార్గదర్శనం",
    "daily_horoscope_description": "మీ రాశి చిహ్నానికి అనుకూలంగా వ్యక్తిగతీకరించిన దైనిక రాశిఫల భవిష్యవాణులను పొందండి. ప్రేమ, కెరీర్, ఆరోగ్యం మరియు ఆర్థిక వ్యవహారాలపై దైనిక అదృష్ట సంఖ్యలు, రంగులు మరియు మీ రోజును విజయవంతంగా నావిగేట్ చేయడానికి కాస్మిక్ మార్గదర్శనంతో అంతర్దృష్టులను అందుకోండి.",

    // Service Information
    "enter_details_for_horoscope": "దైనిక రాశిఫలం కోసం మీ వివరాలను నమోదు చేయండి",
    "daily_horoscope_subscription": "దైనిక రాశిఫల సబ్‌స్క్రిప్షన్",
    "service_price": "సేవా ధర",
    "daily_horoscope_subscription_note": "వ్యక్తిగతీకరించిన దైనిక రాశిఫల డెలివరీ కోసం మాసిక సబ్‌స్క్రిప్షన్",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_cosmic_influence": "వ్యక్తిగతీకరించిన భవిష్యవాణుల కోసం మీ పేరు కాస్మిక్ కంపనలతో ప్రతిధ్వనిస్తుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_zodiac_sign": "మీ రాశి చిహ్నం మరియు వ్యక్తిగతీకరించిన భవిష్యవాణులను నిర్ధారించడానికి అవసరం",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ దైనిక రాశిఫలం ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Horoscope Features
    "daily_predictions": "దైనిక భవిష్యవాణులు",
    "love_relationship_insights": "ప్రేమ మరియు సంబంధ అంతర్దృష్టులు",
    "career_money_guidance": "కెరీర్ మరియు డబ్బు మార్గదర్శనం",
    "health_wellness_tips": "ఆరోగ్యం మరియు క్షేమం చిట్కాలు",
    "lucky_numbers_colors": "అదృష్ట సంఖ్యలు మరియు రంగులు",
    "monthly_horoscope_bonus": "మాసిక రాశిఫల బోనస్",

    "what_you_get": "మీ దైనిక రాశిఫలంలో ఉన్నవి",
    "personalized_daily_readings": "వ్యక్తిగతీకరించిన దైనిక రీడింగ్‌లు",
    "love_career_predictions": "ప్రేమ మరియు కెరీర్ భవిష్యవాణులు",
    "daily_lucky_elements": "దైనిక అదృష్ట అంశాలు",
    "monthly_bonus_insights": "మాసిక బోనస్ అంతర్దృష్టులు",

    // Actions & Buttons
    "subscribe_to_horoscope": "దైనిక రాశిఫలానికి సబ్‌స్క్రైబ్ చేయండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "సబ్‌స్క్రిప్షన్‌ను సెటప్ చేస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "horoscope_subscription_processing": "మీ దైనిక రాశిఫల సబ్‌స్క్రిప్షన్ ఇప్పుడు చురుకుగా ఉంది. ఆత్మవిశ్వాసంతో మీ రోజును ప్రారంభించడానికి ప్రతిరోజూ ఉదయం వ్యక్తిగతీకరించిన కాస్మిక్ మార్గదర్శనం అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "daily_delivery": "దైనిక డెలివరీ",
    "daily_horoscope_delivery_note": "మీ వ్యక్తిగతీకరించిన రాశిఫలం ప్రతిరోజూ ఉదయం వస్తుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో దైనిక రాశిఫలం అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "దైనిక రాశిఫలం అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ దైనిక రాశిఫల ప్యాకేజ్",
    "daily_horoscope_reading": "వ్యక్తిగతీకరించిన దైనిక రాశిఫల రీడింగ్",
    "love_relationship_daily_insights": "ప్రేమ మరియు సంబంధ దైనిక అంతర్దృష్టులు",
    "career_financial_guidance": "కెరీర్ మరియు ఆర్థిక దైనిక మార్గదర్శనం",
    "health_wellness_daily_tips": "ఆరోగ్యం మరియు క్షేమం దైనిక చిట్కాలు",
    "monthly_special_predictions": "మాసిక ప్రత్యేక భవిష్యవాణులు",

    // Visual Content
    "sample_daily_horoscope": "నమూనా దైనిక రాశిఫలం",
    "leo_horoscope_today": "ఈరోజు సింహ రాశి",
    "sample_horoscope_reading": "ఈరోజు వ్యక్తిగత వృద్ధి మరియు ఆర్థిక లాభాలకు అవకాశాలను తెస్తుంది",
    "sample_horoscope_preview": "కాస్మిక్ అంతర్దృష్టులతో మీ వ్యక్తిగతీకరించిన దైనిక రాశిఫల మునుజూపు",
    "zodiac_signs": "రాశి చిహ్నాలు",

    // Zodiac Sign Names
    "aries": "మేషం",
    "taurus": "వృషభం",
    "gemini": "మిథునం",
    "cancer": "కర్కాటకం",
    "leo": "సింహం",
    "virgo": "కన్య",
    "libra": "తుల",
    "scorpio": "వృశ్చికం",
    "sagittarius": "ధనుస్సు",
    "capricorn": "మకరం",
    "aquarius": "కుంభం",
    "pisces": "మీనం",

    // Status & Processing
    "your_horoscope_status": "మీ రాశిఫల సబ్‌స్క్రిప్షన్ స్థితి",
    "processing_your_subscription": "మీ సబ్‌స్క్రిప్షన్‌ను యాక్టివేట్ చేస్తోంది",
    "subscription_processing_message": "మీ దైనిక రాశిఫల సబ్‌స్క్రిప్షన్ యాక్టివేట్ చేయబడుతోంది. రేపు ఉదయం నుండి వ్యక్తిగతీకరించిన కాస్మిక్ మార్గదర్శనం అందుకోవడం ప్రారంభిస్తారు.",
    "subscription_id": "సబ్‌స్క్రిప్షన్ ID",
    "status": "స్థితి",
    "processing": "యాక్టివేట్ చేస్తోంది",
    "active": "చురుకుగా ఉంది",
    "confirmation_email_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "daily_whatsapp_updates": "దైనిక వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "first_horoscope_tomorrow": "మొదటి రాశిఫలం రేపు ఉదయం అందించబడుతుంది",

    // Support & Contact
    "contact_support": "రాశిఫల మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "subscription_failed": "సబ్‌స్క్రిప్షన్ యాక్టివేషన్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Daily Horoscope Categories
    "general_forecast": "సాధారణ అంచనా",
    "love_romance": "ప్రేమ మరియు శృంగారం",
    "career_profession": "కెరీర్ మరియు వృత్తి",
    "health_wellbeing": "ఆరోగ్యం మరియు క్షేమం",
    "finance_money": "ఆర్థికం మరియు డబ్బు",
    "family_relationships": "కుటుంబం మరియు సంబంధాలు",
    "travel_adventure": "ప్రయాణం మరియు సాహసం",
    "spiritual_growth": "ఆధ్యాత్మిక వృద్ధి",

    // Lucky Elements
    "lucky_number": "అదృష్ట సంఖ్య",
    "lucky_color": "అదృష్ట రంగు",
    "lucky_time": "అదృష్ట సమయం",
    "lucky_direction": "అదృష్ట దిశ",
    "lucky_gemstone": "అదృష్ట రత్నం",
    "avoid_color": "తప్పించవలసిన రంగు",
    "avoid_time": "తప్పించవలసిన సమయం",

    // Daily Ratings
    "love_rating": "ప్రేమ రేటింగ్",
    "career_rating": "కెరీర్ రేటింగ్",
    "health_rating": "ఆరోగ్య రేటింగ్",
    "finance_rating": "ఆర్థిక రేటింగ్",
    "overall_rating": "మొత్తం రోజు రేటింగ్",

    // Planetary Influences
    "planetary_influence": "గ్రహ ప్రభావం",
    "moon_phase": "చంద్ర దశ",
    "ruling_planet": "ఈరోజు పాలక గ్రహం",
    "planetary_transit": "ప్రధాన గ్రహ గమనం",
    "retrograde_alert": "వక్రగతి హెచ్చరిక",

    // Relationship Insights
    "single_horoscope": "ఒంటరివారి ప్రేమ అంచనా",
    "relationship_horoscope": "సంబంధ అంచనా",
    "marriage_horoscope": "వివాహ అంచనా",
    "friendship_forecast": "మిత్రత్వ అంచనా",
    "family_harmony": "కుటుంబ సామరస్యం",

    // Career Guidance
    "job_prospects": "ఉద్యోగ అవకాశాలు",
    "business_forecast": "వ్యాపార అంచనా",
    "investment_advice": "పెట్టుబడి సలహా",
    "career_decisions": "కెరీర్ నిర్ణయాలు",
    "workplace_relationships": "కార్యాలయ సంబంధాలు",

    // Health Tips
    "physical_health": "శారీరక ఆరోగ్యం",
    "mental_wellbeing": "మానసిక క్షేమం",
    "exercise_recommendation": "వ్యాయామం సిఫార్సు",
    "diet_suggestion": "ఆహార సూచన",
    "stress_management": "ఒత్తిడి నిర్వహణ",

    // Weekly & Monthly
    "weekly_overview": "వారపు సమీక్ష",
    "monthly_highlights": "మాసిక ముఖ్యాంశాలు",
    "seasonal_forecast": "కాలానుగుణ అంచనా",
    "year_ahead": "ముందు సంవత్సరం మునుజూపు",

    // Compatibility
    "compatible_signs_today": "ఈరోజు అనుకూల రాశులు",
    "challenging_signs": "సవాలు కలిగించే రాశులు",
    "best_match_today": "ఈరోజు అత్యుత్తమ మ్యాచ్",
    "avoid_conflicts_with": "వీరితో వివాదాలను తప్పించండి",

    // Remedies & Tips
    "daily_remedy": "దైనిక పరిహారం",
    "positive_affirmation": "సానుకూల ధృవీకరణ",
    "meditation_tip": "ధ్యాన చిట్కా",
    "crystal_recommendation": "స్ఫటిక సిఫార్సు",
    "mantra_for_today": "ఈరోజు మంత్రం",

    // Special Occasions
    "birthday_special": "పుట్టినరోజు ప్రత్యేక అంచనా",
    "new_moon_influence": "అమావాస్య ప్రభావం",
    "full_moon_impact": "పౌర్ణమి ప్రభావం",
    "eclipse_effects": "గ్రహణ ప్రభావాలు",
    "festival_predictions": "పండుగ భవిష్యవాణులు",

    // Subscription Management
    "subscription_active": "సబ్‌స్క్రిప్షన్ చురుకుగా ఉంది",
    "next_billing": "తదుపరి బిల్లింగ్ తేదీ",
    "cancel_subscription": "సబ్‌స్క్రిప్షన్ రద్దు చేయండి",
    "modify_subscription": "సబ్‌స్క్రిప్షన్ మార్చండి",
    "subscription_history": "సబ్‌స్క్రిప్షన్ చరిత్ర",

    // Personalization
    "customize_preferences": "ప్రాధాన్యతలను అనుకూలీకరించండి",
    "delivery_time": "ప్రాధాన్య డెలివరీ సమయం",
    "content_focus": "కంటెంట్ దృష్టి రంగాలు",
    "notification_settings": "నోటిఫికేషన్ సెట్టింగ్‌లు",

    // Premium Features
    "premium_insights": "ప్రీమియం అంతర్దృష్టులు",
    "detailed_analysis": "వివరణాత్మక విశ్లేషణ",
    "astrologer_notes": "జ్యోతిష్యుడి వ్యక్తిగత గమనికలు",
    "priority_support": "ప్రాధాన్య కస్టమర్ మద్దతు"
};
